"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fmko_ts_common_1 = require("fmko-ts-common");
const InfoPanelOptions_1 = require("./InfoPanelOptions");
/**
 * Sorts the added InfoPanels from high to low
 */
class InfoPanelAutoSorter extends fmko_ts_common_1.Widget {
    constructor() {
        super();
        this.element = document.createElement("div");
        this.infoPanelSet = new Set();
    }
    addInfoPanels(...infoPanelSet) {
        const that = this;
        for (const infoPanel of infoPanelSet) {
            if (!this.infoPanelSet.has(infoPanel)) {
                const originalReRender = infoPanel.reRender;
                infoPanel.reRender = function () {
                    originalReRender.apply(this, [...arguments]);
                    that.updateDomOnAddOrChange();
                };
                this.infoPanelSet.add(infoPanel);
            }
        }
        this.updateDomOnAddOrChange();
    }
    removeInfoPanel(infoPanel) {
        this.infoPanelSet.delete(infoPanel);
        this.removeInfoPanelFromDom(infoPanel);
    }
    /**
     * Perform proper hydration
     * @private
     */
    updateDomOnAddOrChange() {
        const sortedInfoPanel = Array.from(this.infoPanelSet.values()).sort((a, b) => {
            const aSeverity = a.getInfoPanelSeverity();
            const bSeverity = b.getInfoPanelSeverity();
            const infoPanelPriority = {
                [InfoPanelOptions_1.InfoPanelSeverity.ERROR]: 0,
                [InfoPanelOptions_1.InfoPanelSeverity.WARNING]: 1,
                [InfoPanelOptions_1.InfoPanelSeverity.INFO]: 2
            };
            return infoPanelPriority[aSeverity] - infoPanelPriority[bSeverity];
        });
        sortedInfoPanel.forEach((infoPanel, index) => {
            const child = this.element.children[index];
            if (!child) {
                this.element.appendChild(infoPanel.element);
            }
            else if (child !== infoPanel.element) {
                this.element.replaceChild(infoPanel.element, child);
            }
        });
    }
    removeInfoPanelFromDom(infoPanel) {
        for (const currentElement of Array.from(this.element.children)) {
            if (currentElement === infoPanel.element) {
                this.element.removeChild(currentElement);
                return;
            }
        }
    }
}
exports.default = InfoPanelAutoSorter;
//# sourceMappingURL=InfoPanelAutoSorter.js.map